/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PurchaseOfflineInvoiceBillingInfo } from '../../models/purchase-offline-invoice-billing-info';

export interface CreateOfflineInvoiceForProfile$Params {

/**
 * ID of profile
 */
  id: number;

/**
 * ID of plan from ChargeBeee
 */
  planId: string;
  
    /**
     * Billing info for customer
     */
    body: PurchaseOfflineInvoiceBillingInfo
}

export function createOfflineInvoiceForProfile(http: HttpClient, rootUrl: string, params: CreateOfflineInvoiceForProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, createOfflineInvoiceForProfile.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('planId', params.planId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

createOfflineInvoiceForProfile.PATH = '/rest/profile/{id}/purchase/offline-invoice/{planId}';
